<template>
  <div>
    <div class="list-group-item header">
      <div class="form-row align-items-center">
        <div class="col-12 col-md-6">
          <div class="title">
            Section {{ this.standardNumber }}: {{ this.standard.Name }}
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="body float-md-right">
            Elements in place:
            <strong
              >{{ this.positiveResponseCount }} of
              {{ this.questions.length }}</strong
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="list-group-item item"
      v-for="(question, i) in this.questions"
      :key="question.Id"
    >
      <ActionPlanQuestion :question="question" :questionNumber="i + 1" />
    </div>
  </div>
</template>

<script>
import ActionPlanQuestion from "@/components/actionplan-question";

export default {
  name: "ActionPlanStandard",
  components: {
    ActionPlanQuestion
  },
  data() {
    return {
      questions: [],
      positiveResponseCount: 0
    };
  },
  props: {
    standard: {
      type: Object,
      default: () => {}
    },
    standardNumber: {
      type: Number,
      default: () => 0
    }
  },
  created() {
    this.getQuestions();
    this.getPositiveResponseCount();
  },
  methods: {
    getQuestions() {
      this.standard.Sections.forEach(section => {
        this.questions = this.questions.concat(section.Questions);
      });
    },
    getPositiveResponseCount() {
      this.questions.forEach(question => {
        if (question.SAT_SavedResponses.PositiveResponse)
          this.positiveResponseCount++;
      });
    }
  },
  computed: {}
};
</script>

<style lang="sass" scoped></style>
